/* eslint-disable */
import * as React from 'react';
import { Loader } from "@thd-olt-component-react/loader";

export const LoadingMessage = ({loadingText}) => {
  return (
    <div className="container">
      <div className="pre-loader" style={{flexDirection: 'column'}}>
        <h4 style={{marginBottom: 25}}>
          {loadingText}
        </h4>
        <Loader active/>
      </div>
    </div>
  );
}
